import dayjs from 'dayjs';
import { array, date, number, object, string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const relatedPartiesValidations = {
  documentsList: string().required('Please select a document type').typeError('Please select a document type'),

  entityType: string().required('UBO Type is required'),

  percentageHolding: number()
    .required('Please enter percentage of benefits')
    .min(1, 'Percentage of benefits cannot be less than 1')
    .max(100, 'Percentage of benefits cannot be more than 100')
    .typeError('Please enter valid percentage of benefits')
    .test('is-valid-decimal', 'Please enter a number with up to 2 decimal places', function (value) {
      const regex = RegexUtils.percentageHoldingRegex;
      return regex.test(String(value));
    })
    .test('is-sum-more-than-100', 'Total Percentage of benefits cannot be more than 100.', function (value) {
      const { total } = this.parent;
      if (total && value) {
        return Number(total) + Number(value) <= 100;
      }
      return true;
    })
    .nullable(),

  companyRegistrationDate: date().when('entityType', {
    is: (val: string) => val === 'INSTITUTION',
    then: () =>
      date()
        .required('Please provide incorporation date')
        .max(dayjs().toDate(), 'Please provide valid incorporation date')
        .typeError('Please provide a valid incorporation date'),
    otherwise: () => date().notRequired().nullable(),
  }),

  companyRegisterName: string().when('entityType', {
    is: (val: string) => val === 'INSTITUTION',
    then: () => string().required('Please enter trust name').max(200, 'Character length exceeded').typeError('Please enter valid trust name').trim(),
    otherwise: () => string().notRequired().nullable(),
  }),

  relationship: object().when('entityType', {
    is: () => (val: string) => val === 'INDIVIDUAL',
    then: () =>
      object()
        .shape({
          label: string().required('Please select relation type'),
          value: string(),
        })
        .nullable()
        .required('Please select relation type'),
    otherwise: () =>
      object()
        .shape({
          label: string().nullable(),
          value: string().nullable(),
        })
        .notRequired()
        .nullable(),
  }),

  documents: array()
    .min(1, 'Please upload a document')
    .of(
      object().shape({
        id: string(),
      })
    )
    .required('Please upload a document')
    .typeError('Please upload a document'),
};
